export default __webpack_public_path__ + "static/media/thumbnail.73fcdd27.png";